"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("../../theme"));

var _Box = _interopRequireDefault(require("../Box"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var icons = (0, _styledSystem.variant)({
  key: 'icons'
});
var Icon = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Icon",
  componentId: "sc-1ed12mx-0"
})(["display:inline-block;", " ", " ", ""], _styledSystem.fontSize, icons, _styledSystem.color);
Icon.propTypes = _objectSpread({}, _Box["default"].propTypes, {}, _styledSystem.fontSize.propTypes, {
  variant: _propTypes["default"].oneOf(['default', 'warn', 'danger', 'neutral', 'primary'])
});
Icon.defaultProps = {
  theme: _theme["default"],
  variant: 'default',
  fontSize: 4
};
/** @component */

var _default = Icon;
exports["default"] = _default;